import styled from 'styled-components';

export const TitleStyled = styled.h1`
    font-size: ${(props) => props.fontSize || '1.5rem'} !important;
    font-weight: 600;
    color: var(--color-primary);
    margin: ${(props) => props.marginHorizontal} 0 !important;

    @media (max-width: 767px) {
        margin: 16px 0 !important;
    }
`;
